// import React from "react";
// import editLight from "assets/images/manageTeam/editLight.svg";
// import editDark from "assets/images/manageTeam/editDark.svg";
// import deleteLight from "assets/images/manageTeam/deleteLight.svg";
// import deleteDark from "assets/images/manageTeam/deleteDark.svg";
// import "./roleTable.scss";
// import useTheme from "hooks/observer";
// import useScreenMobile from "hooks/useScreen";
// import Tooltip from "components/Tooltip/index";

// function RoleTable({ roles, handleEditRole, handleShowDelete }) {
//   const theme = useTheme();
//   const isMobile = useScreenMobile({ size: 992 });

//   const maxVisibleUsers = 2;
//   const maxVisibleTeams = 1;
//   const maxVisibleOperations = 2;

//   const editIcon = theme === "light" ? editLight : editDark;
//   const deleteIcon = theme === "light" ? deleteLight : deleteDark;

//   function truncateItems(items, maxVisible) {
//     const visible = items.slice(0, maxVisible);
//     const remainingData = items.slice(maxVisible);
//     const remaining = remainingData.length;
//     return { visible, remaining, remainingData };
//   }

//   return (
//     <div className="RoleTable">
//       {isMobile ? (
//         <div className="mobileRoleContainer">
//           {roles.map((role, index) => {
//             const {
//               visible: visibleUsers,
//               remaining: userOverflow,
//               remainingData: remainingUsers
//             } = truncateItems(role.users, maxVisibleUsers);
//             const {
//               visible: visibleTeams,
//               remaining: teamOverflow,
//               remainingData: remainingTeams
//             } = truncateItems(role.team, maxVisibleTeams);
//             const {
//               visible: visibleOperations,
//               remaining: operationOverflow,
//               remainingData: remainingOperations
//             } = truncateItems(role.operations, maxVisibleOperations);

//             return (
//               <div key={index} className="mobileRoleCard">
//                 <div className="mobileRoleHeader">
//                   <h3 className="mobileRoleName">{role.roles}</h3>
//                   <div className="mobileRoleActions">
//                     <img
//                       src={editIcon}
//                       alt="Edit role"
//                       onClick={() => handleEditRole(index)}
//                       style={{ cursor: "pointer" }}
//                     />
//                     <img
//                       src={deleteIcon}
//                       alt="Delete role"
//                       onClick={() => handleShowDelete(index)}
//                       style={{ cursor: "pointer" }}
//                     />
//                   </div>
//                 </div>

//                 <div className="mobileRoleSection">
//                   <div className="mobileRoleLabel">Users</div>
//                   <div className="mobileRolesContainer">
//                     {visibleUsers.map((user, idx) => (
//                       <div key={idx} className="mobileRoleItem usersItem">
//                         <p>{user}</p>
//                       </div>
//                     ))}
//                     {userOverflow > 0 && (
//                       <Tooltip
//                         text={remainingUsers.join(", ")}
//                         mockClass={"manageTable"}
//                       >
//                         <div className="mobileRoleCount">
//                           <p>+{userOverflow}</p>
//                         </div>
//                       </Tooltip>
//                     )}
//                     {role.users.length === 0 && (
//                       <div className="mobileRoleItem">
//                         <p>No users added</p>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 <div className="mobileRoleSection">
//                   <div className="mobileSectionLabel">Teams</div>
//                   <div className="mobileRolesContainer">
//                     {visibleTeams.map((team, idx) => (
//                       <div key={idx} className="mobileRoleItem teamItem">
//                         <p>{team}</p>
//                       </div>
//                     ))}
//                     {teamOverflow > 0 && (
//                       <Tooltip
//                         text={remainingTeams.join(", ")}
//                         mockClass={"manageTable"}
//                       >
//                         <div className="mobileExtraCount">
//                           <p>+{teamOverflow}</p>
//                         </div>
//                       </Tooltip>
//                     )}
//                     {role.team.length === 0 && (
//                       <div className="mobileRoleItem">
//                         <p>No teams added</p>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 <div className="mobileRoleSection">
//                   <div className="mobileSectionLabel">Operations</div>
//                   <div className="mobileRolesContainer">
//                     {visibleOperations.map((operation, idx) => (
//                       <div key={idx} className="mobileRoleItem">
//                         <p>{operation}</p>
//                       </div>
//                     ))}
//                     {operationOverflow > 0 && (
//                       <Tooltip
//                         text={remainingOperations.join(", ")}
//                         position="top"
//                         mockClass={"manageTable"}
//                       >
//                         <div className="mobileExtraCount">
//                           <p>+{operationOverflow}</p>
//                         </div>
//                       </Tooltip>
//                     )}
//                     {role.operations.length === 0 && (
//                       <div className="mobileRoleItem">
//                         <p>No operations added</p>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       ) : (
//         <table className="RoleTable">
//           <thead>
//             <tr>
//               <th className="col-role">Role</th>
//               <th className="col-users">Users</th>
//               <th className="col-teams">Teams</th>
//               <th className="col-operations">Operations</th>
//               <th className="col-actions">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {roles.map((role, index) => {
//               const {
//                 visible: visibleUsers,
//                 remaining: userOverflow,
//                 remainingData: remainingUsers
//               } = truncateItems(role.users, maxVisibleUsers);

//               const {
//                 visible: visibleTeams,
//                 remaining: teamOverflow,
//                 remainingData: remainingTeams
//               } = truncateItems(role.team, maxVisibleTeams);

//               const {
//                 visible: visibleOperations,
//                 remaining: operationOverflow,
//                 remainingData: remainingOperations
//               } = truncateItems(role.operations, maxVisibleOperations);

//               return (
//                 <tr key={index}>
//                   <td className="col-role RoleName">{role.roles}</td>

//                   <td className="col-users Users">
//                     <div className="UsersContainer">
//                       {visibleUsers.map((user, idx) => (
//                         <div key={idx} className="UserItem">
//                           <p>{user}</p>
//                         </div>
//                       ))}
//                       {userOverflow > 0 && (
//                         <Tooltip
//                           text={remainingUsers.join(", ")}
//                           position="top"
//                           mockClass={"manageTable"}
//                         >
//                           <div className="extraCount">
//                             <p>+{userOverflow}</p>
//                           </div>
//                         </Tooltip>
//                       )}
//                       {role.users.length === 0 && (
//                         <div className="UserItem">No users added</div>
//                       )}
//                     </div>
//                   </td>

//                   <td className="col-teams Teams">
//                     <div className="TeamsContainer">
//                       {visibleTeams.map((team, idx) => (
//                         <div key={idx} className="TeamItem">
//                           <p>{team}</p>
//                         </div>
//                       ))}
//                       {teamOverflow > 0 && (
//                         <Tooltip
//                           text={remainingTeams.join(", ")}
//                           position="top"
//                           mockClass={"manageTable"}
//                         >
//                           <div className="extraCount">
//                             <p>+{teamOverflow}</p>
//                           </div>
//                         </Tooltip>
//                       )}
//                       {role.team.length === 0 && (
//                         <div className="TeamItem">No teams added</div>
//                       )}
//                     </div>
//                   </td>

//                   <td className="col-operations Operations">
//                     <div className="OperationsContainer">
//                       {visibleOperations.map((operation, idx) => (
//                         <div key={idx} className="OperationItem">
//                           <p>{operation}</p>
//                         </div>
//                       ))}
//                       {operationOverflow > 0 && (
//                         <Tooltip
//                           text={remainingOperations.join(", ")}
//                           position="top"
//                           mockClass={"manageTable"}
//                         >
//                           <div className="extraCount">
//                             <p>+{operationOverflow}</p>
//                           </div>
//                         </Tooltip>
//                       )}
//                       {role.operations.length === 0 && (
//                         <div className="OperationItem">No operations added</div>
//                       )}
//                     </div>
//                   </td>

//                   <td className="col-actions Actions">
//                     <div className="ActionsContainer">
//                       <img
//                         src={editIcon}
//                         alt="Edit role"
//                         onClick={() => handleEditRole(index)}
//                         style={{ cursor: "pointer" }}
//                       />
//                       <img
//                         src={deleteIcon}
//                         alt="Delete role"
//                         onClick={() => handleShowDelete(index)}
//                         style={{ cursor: "pointer" }}
//                       />
//                     </div>
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// }

// export default RoleTable;



import React from "react";
import editLight from "assets/images/manageTeam/editLight.svg";
import editDark from "assets/images/manageTeam/editDark.svg";
import deleteLight from "assets/images/manageTeam/deleteLight.svg";
import deleteDark from "assets/images/manageTeam/deleteDark.svg";
import "./roleTable.scss";
import useTheme from "hooks/observer";
import useScreenMobile from "hooks/useScreen";
import Tooltip from "components/Tooltip/index";
import showDark from "assets/images/manageTeam/show.svg";
import showLight from "assets/images/manageTeam/showdark.svg";

function RoleTable({
  roles,
  handleEditRole,
  handleShowDelete,
  handleShowPermissions
}) {
  const theme = useTheme();
  const isMobile = useScreenMobile({ size: 992 });
  const isMobileStrict = useScreenMobile({ size: 768 });
  const [activeMenu, setActiveMenu] = React.useState(null);

  const maxVisibleOperations = 5;

  const editIcon = theme === "light" ? editLight : editDark;
  const deleteIcon = theme === "light" ? deleteLight : deleteDark;
  const showIcon = theme === "light" ? showLight : showDark;

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        activeMenu !== null &&
        !event.target.closest(".mobile-action-menu-container")
      ) {
        setActiveMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [activeMenu]);

  function truncateItems(items, maxVisible) {
    const visible = items.slice(0, maxVisible);
    const remaining = items.length - maxVisible;
    return { visible, remaining };
  }

  return (
    <div className="RoleTable">
      {isMobileStrict ? (
        <table className="RoleTableMobile">
          <thead>
            <tr>
              <th className="col-role">Role</th>
              <th className="col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            {roles.map((role, index) => (
              <tr key={index}>
                <td className="col-role RoleName">{role.roles}</td>
                <td className="col-actions Actions">
                  <div className="mobile-action-menu-container">
                    <button
                      className="three-dot-btn"
                      onClick={() =>
                        setActiveMenu(activeMenu === index ? null : index)
                      }
                    >
                      ⋮
                    </button>
                    {activeMenu === index && (
                      <div
                        className={`mobile-action-menu ${index === roles.length - 1 && roles.length > 1
                            ? "open-upward"
                            : ""
                          }`}
                      >
                        <div className="menu-item operations-label">
                          <p className="label-title">
                            Operations ({role.operations.length})
                          </p>
                          {role.operations.length > 0 && (
                            <p className="operations-list-text">
                              {role.operations.map((op) => op.role).join(", ")}
                            </p>
                          )}
                        </div>
                        <div
                          className="menu-item"
                          onClick={() => {
                            handleShowPermissions(index);
                            setActiveMenu(null);
                          }}
                        >
                          <img src={showIcon} alt="view" />
                          View
                        </div>
                        <div
                          className="menu-item"
                          onClick={() => {
                            handleEditRole(index);
                            setActiveMenu(null);
                          }}
                        >
                          <img src={editIcon} alt="edit" />
                          Edit
                        </div>
                        <div
                          className="menu-item"
                          onClick={() => {
                            handleShowDelete(index);
                            setActiveMenu(null);
                          }}
                        >
                          <img src={deleteIcon} alt="delete" />
                          Delete
                        </div>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : isMobile ? (
        <div className="mobileRoleContainer">
          {roles.map((role, index) => {
            const {
              visible: visibleOperations,
              remaining: operationOverflow
            } = truncateItems(role.operations, maxVisibleOperations);

            return (
              <div key={index} className="mobileRoleCard">
                <div className="mobileRoleHeader">
                  <h3 className="mobileRoleName">{role.roles}</h3>
                  <div className="mobileRoleActions">
                    <img
                      src={editIcon}
                      alt="Edit role"
                      onClick={() => handleEditRole(index)}
                      style={{ cursor: "pointer" }}
                    />
                    <img
                      src={deleteIcon}
                      alt="Delete role"
                      onClick={() => handleShowDelete(index)}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>

                <div className="mobileRoleSection">
                  <div className="mobileSectionLabel">Operations</div>
                  <div className="mobileRolesContainer">
                    {role.operations.length > 0 ? (
                      <Tooltip
                        text={role.operations.map(op => op.name).join(", ")}
                        position="top"
                        mockClass={"manageTable"}
                      >
                        <p>
                          {visibleOperations.map(op => op.name).join(", ")}
                          {operationOverflow > 0 && `, +${operationOverflow}`}
                        </p>
                      </Tooltip>
                    ) : (
                      <p>No operations added</p>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <table className="RoleTable">
          <thead>
            <tr>
              <th className="col-role">Role</th>
              <th className="col-operations">Operations</th>
              <th className="col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            {roles.map((role, index) => {
              const {
                visible: visibleOperations,
                remaining: operationOverflow
              } = truncateItems(role.operations, maxVisibleOperations);

              return (
                <tr key={index}>
                  <td className="col-role RoleName">{role.roles}</td>
                  <td className="col-operations Operations">
                    {role.operations.length > 0 ? (
                      <p>
                        {visibleOperations.map(op => op.role).join(", ")}
                        {operationOverflow > 0 && `, +${operationOverflow}`}
                      </p>
                    ) : (
                      <p>No operations added</p>
                    )}
                  </td>
                  <td className="col-actions Actions">
                    <div className="ActionsContainer">
                      <span data-tooltip="View" className="action-icon-wrap">
                        <img
                          src={showIcon}
                          alt="show permissions"
                          onClick={() => handleShowPermissions(index)}
                          style={{ cursor: "pointer" }}
                        />
                      </span>
                      <span data-tooltip="Edit" className="action-icon-wrap">
                        <img
                          src={editIcon}
                          alt="Edit role"
                          onClick={() => handleEditRole(index)}
                          style={{ cursor: "pointer" }}
                        />
                      </span>
                      <span data-tooltip="Trash" className="action-icon-wrap">
                        <img
                          src={deleteIcon}
                          alt="Delete role"
                          onClick={() => handleShowDelete(index)}
                          style={{ cursor: "pointer" }}
                        />
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default RoleTable;